import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import { Button as ReactButton } from '@mui/material';
import {
  ArrowBackIos,
  FilterNone
  } from '@mui/icons-material';
  import { WithTracking } from "../WithTracking";
  const Button = WithTracking(ReactButton);

const styles = theme => ({
  bar: {
    minHeight: 50,
    background: theme.palette.common.white,
    borderBottom: '1px solid #c8c8c8'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  extraMargin: {
    marginRight: 20
  }
});

class ClonePlacementToolbar extends Component {

  render() {
    const { classes, onBack, onClone, disableClone } = this.props;
    return(
      <div>
        <Toolbar className={classes.bar}>
          <Button color="primary" className={classes.extraMargin} onClick={onBack} tracking={{action: "Back to Placement"}}>
            <ArrowBackIos className={classes.leftIcon} />
            Back to Placement
          </Button>

          <Button color="primary" disabled={disableClone} onClick={onClone} tracking={{action: "Clone Placement"}}>
            <FilterNone className={classes.leftIcon} />
            Clone Placement
          </Button>
        </Toolbar>
      </div>
    )
  }
}

ClonePlacementToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  onClone: PropTypes.func.isRequired
};

export default withStyles(styles)(ClonePlacementToolbar);


